import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'terms-conditions-content',
  templateUrl: './terms-conditions-content.component.html',
  styleUrls: ['./terms-conditions-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TermsConditionsContentComponent {}
